<template lang="pug">
canvas.canvas-drawing-base(
  @mousedown='dragStart',
  @mouseup='dragEnd',
  @mouseout='dragEnd',
  @mousemove='dragging',
  @touchstart='dragStart',
  @touchend='dragEnd',
  @touchcancel='dragEnd',
  @touchmove='dragging',
  ref='canvasElement'
)
</template>

<script lang="ts">
import { Component, Vue, Ref } from 'vue-property-decorator'

/**
 * 手書き機能用のcanvasタグ規定値
 *
 * マウス/タッチのイベントを統合して返す
 */
@Component
export default class CanvasDrawingBase extends Vue {
  // canvasタグアクセス用
  @Ref()
  public canvasElement!: HTMLCanvasElement

  // canvasのcontext情報を保持する
  private canvasContext: CanvasRenderingContext2D | null = null

  // ドラッグ中かを保持するフラグ
  private isDragging = false

  /**
   * 描画コンテキストの参照用メソッド
   */
  public get context(): CanvasRenderingContext2D {
    // 取得済みの場合はそのまま返す
    if (this.canvasContext) {
      return this.canvasContext
    }

    // 未取得の場合は取得して返す
    this.canvasContext = this.canvasElement.getContext('2d')

    // コンテキスト生成失敗時は例外を発生させる(実運用では発生しない想定)
    if (!this.canvasContext) {
      throw new Error('描画コンテキストの生成に失敗しました。')
    }

    return this.canvasContext
  }

  /**
   * canvasのサイズを再設定する
   */
  public setCanvasSize(width: number, height: number) {
    this.canvasElement.width = width
    this.canvasElement.height = height
  }

  /**
   * ドラッグ開始
   */
  private dragStart(e: TouchEvent | MouseEvent): void {
    this.isDragging = true
    this.$emit('dragStart', e)
  }

  /**
   * ドラッグ終了
   */
  private dragEnd(e: TouchEvent | MouseEvent): void {
    // ドラッグ中でない場合はイベントを発火しない
    if (!this.isDragging) {
      return
    }
    this.isDragging = false
    this.$emit('dragEnd', e)
  }

  /**
   * ドラッグ中イベント
   */
  private dragging(e: TouchEvent | MouseEvent): void {
    // ドラッグ中のみイベントを発火させる
    if (this.isDragging) {
      this.$emit('dragging', e)
    }
  }
}
</script>

<style lang="stylus" scoped>
.canvas-drawing-base
  aspect-ratio auto
</style>
